import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../assets/css/pages/learning.css';
import course1 from '../../assets/images/bmp.png';
import course2 from '../../assets/images/disease_mngt.png';

const coursesData = [
    {
        id: 1,
        title: "Best Management Practices in Aquaculture",
        description: "Master the essential practices for successful aquaculture management",
        duration: "8 hours",
        thumbnail: course1,
        progress: 0,
        modules: 12,
        enrolled: 1234,
        instructor: "Dr. John Smith"
    },
    {
        id: 2,
        title: "Disease Management in Fish Farming",
        description: "Learn to identify, prevent and treat common fish diseases",
        duration: "6 hours",
        thumbnail: course2,
        progress: 0,
        modules: 8,
        enrolled: 856,
        instructor: "Dr. Sarah Johnson"
    },
    // Add more courses as needed
];

const LearningPage = () => {
    const navigate = useNavigate();

    const handleCourseClick = (courseId) => {
        navigate(`/learning/course/${courseId}`);
    };

    return (
        <div className="learning-page">
            <div className="courses-hero">
                <h1>Aquaculture Learning Center</h1>
                <p>Enhance your aquaculture knowledge with our expert-led courses</p>
            </div>

            <div className="courses-grid">
                {coursesData.map(course => (
                    <div 
                        key={course.id} 
                        className="course-card"
                        onClick={() => handleCourseClick(course.id)}
                    >
                        <div className="course-thumbnail">
                            <img src={course.thumbnail} alt={course.title} />
                            <span className="duration">{course.duration}</span>
                        </div>
                        <div className="course-content">
                            <h3>{course.title}</h3>
                            <p>{course.description}</p>
                            <div className="course-meta">
                                <span className="modules">
                                    <i className="icon-module"></i>
                                    {course.modules} Modules
                                </span>
                                <span className="enrolled">
                                    <i className="icon-user"></i>
                                    {course.enrolled} Enrolled
                                </span>
                            </div>
                            <div className="course-footer">
                                {/* <span className="instructor">{course.instructor}</span> */}
                                {course.progress > 0 && (
                                    <div className="progress-bar">
                                        <div 
                                            className="progress" 
                                            style={{width: `${course.progress}%`}}
                                        ></div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="resources-section">
                <h2>Additional Learning Resources</h2>
                <p>Explore these trusted resources for more aquaculture knowledge</p>
                
                <div className="resources-grid">
                    <a 
                        href="https://www.fishbase.se/" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="resource-card"
                    >
                        <img 
                            src="https://www.fishbase.se/images/png/Fishbase-logo-CMYK.png" 
                            alt="FishBase" 
                        />
                        <h3>FishBase</h3>
                        <p>FishBase is a global biodiversity information system on finfishes .</p>
                    </a>

                    <a 
                        href="https://www.fao.org/fishery/en/aquaculture" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="resource-card"
                    >
                        <img 
                            src="https://www.fao.org/fileadmin/templates/family-farming-decade/images/FAO-IFAD-Logos/FAO-Logo-EN.svg" 
                            alt="FAO" 
                        />
                        <h3>FAO Aquaculture</h3>
                        <p>Food and Agriculture Organization of the United Nations</p>
                    </a>

                    <a 
                        href="https://www.worldfishcenter.org/" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="resource-card"
                    >
                        <img 
                            src="https://upload.wikimedia.org/wikipedia/en/thumb/9/9e/WorldFish_logo.svg/1200px-WorldFish_logo.svg.png" 
                            alt="WorldFish" 
                        />
                        <h3>WorldFish</h3>
                        <p>Research and Innovation in Aquatic Food Systems</p>
                    </a>

                    <a 
                        href="https://www.was.org/" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="resource-card"
                    >
                        <img 
                            src="https://www.was.org/_images/site/logo_main@2x.png" 
                            alt="WAS" 
                        />
                        <h3>World Aquaculture Society</h3>
                        <p>International Forum for Aquaculture Development</p>
                    </a>

                    <a 
                        href="https://www.aquaculturealliance.org/" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="resource-card"
                    >
                        <img 
                            src="https://www.aquaculturealliance.org/wp-content/uploads/2016/03/GAA_RGB.png" 
                            alt="GAA" />
                        <h3>Global Aquaculture Alliance</h3>
                        <p>Promoting Responsible Aquaculture Practices</p>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default LearningPage;